import {BrowserRouter} from 'react-router-dom'
import {AuthProvider} from './providers/auth/AuthProvider.tsx'
import {LocalSettingsProvider} from './providers/localSettings/LocalSettingsProvider.tsx'
import {TrpcProvider} from './providers/trpc/TrpcProvider.tsx'
import {Layout} from './screens/Layout.tsx'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import updateLocale from 'dayjs/plugin/updateLocale'
import localeData from 'dayjs/plugin/localeData'
import dayjs from 'dayjs'
import {getFirstDayOfWeek} from '@package/shared'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(localeData)
dayjs.extend(updateLocale)

const localeName = new Intl.NumberFormat().resolvedOptions().locale
const locale = new Intl.Locale(localeName)

dayjs.updateLocale(dayjs.locale(), {weekStart: getFirstDayOfWeek(locale)})

export default function App() {
  return (
    <BrowserRouter>
      <LocalSettingsProvider>
        <AuthProvider>
          <TrpcProvider>
            <Layout />
          </TrpcProvider>
        </AuthProvider>
      </LocalSettingsProvider>
    </BrowserRouter>
  )
}
